import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import QQMusicDashboard from './pages/QQMusicDashboard';
import QQMusicConfig from './pages/QQMusicConfig';
import CopyTextManagement from './pages/CopyTextManagement';
import UserManagement from './pages/UserManagement';
import AnnouncementManagement from './pages/AnnouncementManagement';
import UseRecord from './pages/UseRecord';

const theme = createTheme({
  palette: {
    primary: { main: '#31c27c' },
    secondary: { main: '#dc004e' },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<ProtectedRoute><QQMusicDashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><QQMusicDashboard /></ProtectedRoute>} />
            <Route path="/qqmusic-config" element={<ProtectedRoute requiredRole={['admin']}><QQMusicConfig /></ProtectedRoute>} />
            <Route path="/copy-texts" element={<ProtectedRoute requiredRole={['admin']}><CopyTextManagement /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute requiredRole={['admin']}><UserManagement /></ProtectedRoute>} />
            <Route path="/announcements" element={<ProtectedRoute requiredRole={['admin']}><AnnouncementManagement /></ProtectedRoute>} />
            <Route path="/use-records" element={<UseRecord />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
